import React from 'react';
import { CartItem, Order } from '../../product/context/ProductContext.tsx';
import { isMobileDevice } from '../../utils/utils.ts';
import CartItemCardMobile from './CartItemCardMobile.tsx';
import CartItemRowDesktop from './CartItemRowDesktop.tsx';

interface Props {
  items?: CartItem[];
  order?: Order;
  showDeleteButton?: boolean;
  deleteFromCart?: (productId: string, purchaseOption: string) => void;
}

const CartItemList: React.FC<Props> = ({
  items,
  order,
  showDeleteButton,
  deleteFromCart,
}) => {
  const isMobile = isMobileDevice();

  const itemsAux: CartItem[] = Array.isArray(order?.cart?.items)
    ? order!.cart.items
    : Array.isArray(order?.cart)
      ? order!.cart
      : Array.isArray(items)
        ? items
        : [];

  if (isMobile) {
    return (
      <div className="cart-item-list margin-top-8">
        {itemsAux.map((item) => (
          <CartItemCardMobile
            key={`${item.product.id}-${item.purchaseOption}`}
            item={item}
            showDeleteButton={showDeleteButton}
            onDelete={deleteFromCart}
          />
        ))}
      </div>
    );
  }

  return (
    <>
      <div className="shopping-cart-header margin-top-8">
        <span className="column-label product">Producto</span>
        <span className="column-label option">Opción</span>
        <span className="column-label quantity">Cantidad</span>
        <span className="column-label unit-price">Precio Unitario</span>
        <span className="column-label total-price">Total</span>
        {showDeleteButton && <span className="column-label delete"></span>}
      </div>

      <div className="shopping-cart-body">
        {itemsAux.map((item) => (
          <CartItemRowDesktop
            key={`${item.product.id}-${item.purchaseOption}`}
            item={item}
            showDeleteButton={showDeleteButton}
            onDelete={deleteFromCart}
          />
        ))}
      </div>
    </>
  );
};

export default CartItemList;
